import FaultTable from 'components/tables/data/fault/FaultTable';
import DashboardLayout from 'layouts/dashboard/DashboardLayout';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import useDepartmentUiMode from 'model/useDepartmentUiMode';

/**
 * Displays a list of all faults for all devices.
 */
export default function FaultsPage() {
  const { mode: departmentUiMode } = useDepartmentUiMode();
  const [searchParams, setSearchParams] = useSearchParams();

  const [initialFilters] = useState(() => {
    const filters: Record<string, any> = {};

    if (searchParams.has('isFixedText')) {
      filters.isFixedText = {
        filterType: 'text',
        type: 'equals',
        filter: searchParams.get('isFixedText'),
      };
    }

    if (searchParams.has('organizationId')) {
      filters['organization.organizationId'] = {
        filterType: 'text',
        type: 'equals',
        filter: searchParams.get('organizationId'),
      };
    }

    if (searchParams.has('departmentId')) {
      filters['department.departmentId'] = {
        mode: departmentUiMode === 'legacy' ? 'exact' : 'subtree',
        filterType: 'text',
        type: 'equals',
        filter: searchParams.get('departmentId'),
      };
    }

    if (searchParams.has('remoteSourceId')) {
      filters['remoteSource.remoteSourceId'] = {
        filterType: 'text',
        type: 'equals',
        filter: searchParams.get('remoteSourceId'),
      };
    }

    return filters;
  });

  useEffect(() => {
    setSearchParams(
      (params) => {
        params.delete('isFixedText');
        params.delete('organizationId');
        params.delete('departmentId');
        params.delete('remoteSourceId');
        return params;
      },
      { replace: true }
    );
  }, []);

  return (
    <DashboardLayout height="screen" breadcrumbs={[{ title: 'Nedostatky zariadení' }]}>
      <FaultTable initialFilters={initialFilters} />
    </DashboardLayout>
  );
}
